// extracted by mini-css-extract-plugin
export default {"imageWrapper":"zR-z","hovered":"AR-z","hoverImage":"BR-z","mainImage":"CR-z","imageNoBackground":"DR-z","fullSizeImage":"ER-z"};